<template>
  <div>
    <b-card>
      <template #header>
        <b-row class="pt-1">
          <b-col cols="10" class="d-flex">
            <b-link :to="{name: 'Appearance'}">
              <h4 class="m-dir-2">
                {{label.pages.testimonials}}
              </h4>
            </b-link>
            /
            <h4 class="m-dirR-2">
              {{ $route.meta.label }}
              <small class="fw1">
                ({{label.pages.manageTestimonials}})
              </small>
            </h4>
          </b-col>
          <b-col cols="2" class="dir-text-start">
            <a
                @click="$router.go(-1)"
                v-b-tooltip.hover.right
                :title="label.pages.previousPage"
                class="mouse-change pe-3"
            >
              <b-icon
                  icon="arrow-left-square-fill"
                  variant="ps-base"
                  scale="1.2"
                  class="align-middle ms-1"
              />
            </a>
          </b-col>
        </b-row>
      </template>
      <b-card-body>
        <b-card-text>
          <DxDataGrid
              :show-row-lines="true"
              :show-column-lines="true"
              :show-borders="true"
              :row-alternation-enabled="true"
              :rtl-enabled="label.direction === 'rtl' ? true : false"
              :data-source="testimonials"
              :columns="fields"
              :remote-operations="true"
              :column-auto-width="true"
              :allow-column-reordering="true"
              :allow-column-resizing="true"
              column-resizing-mode="widget"
              :hover-state-enabled="true"
              :noDataText="checkData"
              @toolbar-preparing="onToolbarPreparing($event)"
              key-expr="id"
              class="ps_Table"
              :height="dataGridHeight"
          >
            <DxSearchPanel
                :visible="true"
                :width="240"
                :placeholder="label.table.search"
            />
            <DxExport
                :enabled="true"
            />
            <template #btnRGroup>
              <b-row class="btnRLanguage-wrapper" v-show="contentLanguageAccess == 1">
                <b-col cols="auto">
                  <label for="language" class="ps_label">
                    {{label.pages.contentLanguage}}
                  </label>
                </b-col>
                <b-col>
                  <v-select
                      input-id="language"
                      :options="languages"
                      v-model="selectedLanguage"
                      :reduce="group => group.id"
                      :clearable="false"
                      size="sm"
                      class="ps_select"
                      @input="setLanguage"
                  >
                  </v-select>
                </b-col>
              </b-row>
            </template>
            <template #btnGroup>
              <div>
                <b-row class="m-dir-2">
                  <b-col cols="auto" class="px-1">
                    <b-button
                        variant="ps-success"
                        class="py-1 pb-2"
                        size="sm"
                        v-b-tooltip.hover
                        :title="label.pages.addOpinion"
                        @click="add"
                    >
                      <b-icon icon="plus" scale="2" color="#fff"></b-icon>
                    </b-button>
                  </b-col>
                  <b-col cols="auto" class="px-0">
                    <b-button
                        variant="ps-secondary"
                        class="py-1 pb-2"
                        size="sm"
                        v-b-tooltip.hover
                        :title="label.table.reload"
                        @click="reloadContent"
                    >
                      <b-icon icon="arrow-repeat" scale="1.5" color="#fff"></b-icon>
                    </b-button>
                  </b-col>
                </b-row>
              </div>
            </template>
            <template #radif="{data}">
              <div>
                {{ data.rowIndex + 1 }}
              </div>
            </template>
            <template #image="{data}">
              <div>
                <img :src="data.data.imageAddress" class="ps_table_inside_img"/>
              </div>
            </template>
            <template #actions="{data}">
              <b-row class="justify-content-center">
                <b-col cols="auto" class="px-0">
                  <button
                      @click="edit(data)"
                      :id="'editBtnTlp-' + data.data.id"
                  >
                    <b-icon icon="dash-square-fill" scale="1.1" variant="ps-edit-icon"></b-icon>
                  </button>
                  <b-tooltip
                    boundary="#app"
                    noninteractive
                    triggers="hover"
                    :target="'editBtnTlp-' + data.data.id"
                  >
                    {{ label.buttons.edit }}
                  </b-tooltip>
                </b-col>
                <b-col cols="auto" class="px-0 pe-2">
                  <button
                      @click="del(data)"
                      :id="'deleteBtnTlp-' + data.data.id"
                  >
                    <b-icon icon="x-square-fill" scale="1.1" variant="ps-delete-icon"></b-icon>
                  </button>
                  <b-tooltip
                    boundary="#app"
                    noninteractive
                    triggers="hover"
                    :target="'deleteBtnTlp-' + data.data.id"
                  >
                    {{ label.buttons.delete }}
                  </b-tooltip>
                </b-col>
                <b-col cols="auto" class="px-0 pe-2">
                  <button
                      @click="setBody(data)"
                      :id="'showCommentBtnTlp-' + data.data.id"
                  >
                    <b-icon-chat-square-fill scale="1.1" variant="success"></b-icon-chat-square-fill>
                  </button>
                  <b-tooltip
                    boundary="#app"
                    noninteractive
                    triggers="hover"
                    :target="'showCommentBtnTlp-' + data.data.id"
                  >
                    {{ label.buttons.ShowComment }}
                  </b-tooltip>
                </b-col>
              </b-row>
            </template>
            <DxLoadPanel :enabled="true"/>
            <DxScrolling mode="virtual"/>
          </DxDataGrid>
        </b-card-text>
      </b-card-body>
    </b-card>

    <!--  Add Modal -->
    <b-modal
        :dir="label.direction"
        v-model="addModal"
        header-bg-variant="ps-success"
        centered
        size="md"
    >
      <template #modal-header>
        <h4 class="text-white fw1">
          {{label.pages.addOpinion}}
        </h4>
        <button
            class="ps-closeModalBtn"
            @click="addModal=false"
            id="closeAddModalTlp"
        >
          <b-icon icon="x-square"></b-icon>
        </button>
        <b-tooltip
          boundary="#app"
          noninteractive
          triggers="hover"
          target="closeAddModalTlp"
        >
          {{ label.buttons.closeModal }}
        </b-tooltip>
      </template>
      <b-container fluid>
        <b-row class="mb-3 mt-1">
          <b-col sm="3" class="pe-0">
            <label for="customerName" class="ps_label">
              {{label.pages.customerName}}
            </label>
          </b-col>
          <b-col sm="9">
            <b-form-input id="customerName" size="sm" v-model="form.customerName"/>
          </b-col>
        </b-row>
        <b-row class="my-3">
          <b-col sm="3" class="pe-0">
            <label for="body" class="ps_label">
              {{label.pages.customerOpinion}}
            </label>
          </b-col>
          <b-col sm="9">
            <b-form-textarea  id="body" size="sm" dir="rtl" v-model="form.body"/>
          </b-col>
        </b-row>
        <b-row v-if="dropZoneAction" class="my-3">
          <b-col sm="3">
            <label for="image" class="ps_label">
              {{label.pages.photo}}
            </label>
          </b-col>
          <b-col sm="auto">
            <drop-zone-custom
                mode="image"
                :isRequired="true"
                :add="dropZoneAction"
                :edit="!dropZoneAction"
                :editSrc="form.imageName"
            />
          </b-col>
        </b-row>
        <b-row v-if="!dropZoneAction" class="my-3">
          <b-col sm="12">
            <drop-zone-custom
                mode="image"
                :isRequired="true"
                :add="dropZoneAction"
                :edit="!dropZoneAction"
                :editSrc="form.imageAddress"
            />
          </b-col>
        </b-row>
        <b-row class="my-3">
          <b-col sm="3">
            <label class="ps_label">
              {{label.form.display}}
            </label>
          </b-col>
          <b-col sm="9">
            <label class="ps-switch">
              <input type="checkbox" v-model="form.isConfirm">
              <span class="slider round"></span>
            </label>
          </b-col>
        </b-row>
      </b-container>
      <template #modal-footer>
        <b-row class="w-100 justify-content-end">
          <b-col cols="auto" class="px-0">
            <b-button
                variant="ps-secondary"
                size="sm"
                class="mx-1"
                @click="addModal=false"
            >
            {{label.buttons.cancel}}
            </b-button>
          </b-col>
          <b-col cols="auto" class="px-0">
            <b-button
                v-if="!loadingBtn"
                variant="ps-success"
                size="sm"
                class="mx-1"
                @click="addTestimonials"
            >
            {{label.buttons.submit}}
            </b-button>
            <b-button
                v-else
                variant="ps-success"
                size="sm"
                class="mx-1"
                disabled
            >
              <b-spinner small></b-spinner>
            </b-button>
          </b-col>
        </b-row>
      </template>
    </b-modal>

    <!-- edit Modal -->
    <b-modal
        :dir="label.direction"
        v-model="editModal"
        header-bg-variant="ps-warning"
        centered
        size="md"
    >
      <template #modal-header>
        <h4 class="text-white fw1">
          {{label.pages.editComment}}
        </h4>
        <button
            class="ps-closeModalBtn"
            @click="editModal=false"
            id="closeEditModalTlp"
        >
          <b-icon icon="x-square"></b-icon>
        </button>
        <b-tooltip
          boundary="#app"
          noninteractive
          triggers="hover"
          target="closeEditModalTlp"
        >
          {{ label.buttons.closeModal }}
        </b-tooltip>
      </template>
      <b-container fluid>
        <b-row class="mb-3 mt-1">
          <b-col sm="3">
            <label for="customerName" class="ps_label">
              {{label.pages.customerName}}
            </label>
          </b-col>
          <b-col sm="9">
            <b-form-input id="customerName" size="sm" v-model="form.customerName"/>
          </b-col>
        </b-row>
        <b-row class="my-3">
          <b-col sm="3" class="pe-0">
            <label for="body" class="ps_label">
              {{label.pages.customerOpinion}}
            </label>
          </b-col>
          <b-col sm="9">
            <b-form-textarea id="body" size="sm" dir="rtl" v-model="form.body"/>
          </b-col>
        </b-row>
        <b-row class="my-3">
          <b-col sm="12">
            <drop-zone-custom
              v-if="refreshImage"
              mode="image"
              :isRequired="true"
              :edit="true"
              :editSrc="form.imageAddress"
            />
          </b-col>
        </b-row>
        <b-row class="my-3">
          <b-col sm="3">
            <label class="ps_label">{{label.form.display}}</label>
          </b-col>
          <b-col sm="9">
            <label class="ps-switch">
              <input type="checkbox" v-model="form.isConfirm">
              <span class="slider round"></span>
            </label>
          </b-col>
        </b-row>
      </b-container>
      <template #modal-footer>
        <b-row class="w-100 justify-content-end">
          <b-col cols="auto" class="px-0">
            <b-button
                variant="ps-secondary"
                size="sm"
                class="mx-1"
                @click="editModal=false"
            >
            {{label.buttons.cancel}}
            </b-button>
          </b-col>
          <b-col cols="auto" class="px-0">
            <b-button
                v-if="!loadingBtn"
                variant="ps-warning"
                size="sm"
                class="mx-1"
                @click="editTestimonials"
            >
            {{label.buttons.saveChanges}}
            </b-button>
            <b-button
                v-else
                variant="ps-warning"
                size="sm"
                class="mx-1"
                disabled
            >
              <b-spinner small></b-spinner>
            </b-button>
          </b-col>
        </b-row>
      </template>
    </b-modal>

    <!-- Delete Service Confirm Modal -->
    <b-modal
        :dir="label.direction"
        v-model="delModal"
        hide-header
        centered
    >
      <b-container fluid>
        <b-row class="mt-2">
          <p class="fs10 text-center lh1 mb-0">
            {{ label.captions.deleteConfirm}}
            <br/>
            <strong>« {{ delTitle }} »</strong>
          </p>
        </b-row>
      </b-container>
      <template #modal-footer>
        <b-row class="w-100 justify-content-end">
          <b-col cols="auto" class="px-0">
            <b-button
                variant="ps-secondary"
                size="sm"
                class="mx-1"
                @click="delModal=false"
            >
            {{label.buttons.cancel}}
            </b-button>
          </b-col>
          <b-col cols="auto" class="px-0">
            <b-button
                v-if="!loadingBtn"
                variant="ps-danger"
                size="sm"
                class="mx-1"
                @click="deletePoster"
            >
            {{label.buttons.deleteConfirm}}
            </b-button>
            <b-button
                v-else
                disabled
                variant="ps-danger"
                size="sm"
                class="mx-1"
            >
              <b-spinner small></b-spinner>
            </b-button>
          </b-col>
        </b-row>
      </template>
    </b-modal>

    <!-- Show Body Modal -->
    <b-modal
        :dir="label.direction"
        v-model="bodyModal"
        hide-header
        centered
    >
      <b-container fluid>
        <b-row class="mt-2">
          <p class="fs10 text-center lh1 mb-0">
            {{ body }}
          </p>
        </b-row>
      </b-container>
      <template #modal-footer>
        <b-row class="w-100 justify-content-end">
          <b-col cols="auto" class="px-0">
            <b-button
                variant="ps-secondary"
                size="sm"
                class="mx-1"
                @click="bodyModal=false"
            >
            {{label.buttons.closeModal}}
            </b-button>
          </b-col>
        </b-row>
      </template>
    </b-modal>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import {dataGridMixin} from '@/components/dataGrid/dataGridMixin'
import  alert from '@/plugins/AlertMessages.js'
import dropZoneCustom from '@/components/DropZoneCustom'
import label from "@/plugins/StaticLabels.js";
import { contentLanguage } from "@/plugins/ContentLangMixin.js";

export default {
  name: "TestimonialsView",
  mixins: [dataGridMixin, contentLanguage],
  components: {
    dropZoneCustom
  },
  data() {
    return {
      refreshImage: true,
      refreshImage2: true,
      dropZoneAction: null,
      dropZoneAction2: null,
      delId: null,
      delTitle: '',
      body: '',
      label,
      fields: [
        {
          cellTemplate: 'radif',
          caption: 'ردیف',
          allowSorting: false,
          allowFiltering: false,
          width: '100',
          cssClass: 'text-center align-middle'
        },
        {
          cellTemplate: 'actions',
          caption: 'عملیات',
          allowSorting: false,
          allowFiltering: false,
          width: '150',
          cssClass: 'text-center align-middle'
        },
        {
          cellTemplate: 'image',
          caption: 'تصویر',
          allowSorting: false,
          allowFiltering: false,
          width: '150',
          cssClass: 'text-center align-middle'
        },
        {
          dataField: 'customerName',
          caption: 'نام مشتری',
          dataType: 'string',
          cssClass: 'text-center align-middle'
        },
        {
          dataField: 'isConfirm',
          caption: 'وضعیت',
          dataType: 'boolean',
          cssClass: 'text-center align-middle'
        },
      ],
      file: null,
      file2: null,
      form: {
        customerName: '',
        body: '',
        isConfirm: true,
        imageName: '',
        imageAddress: '',
        languageId: null,
      },
      addModal: false,
      editModal: false,
      delModal: false,
      bodyModal: false,
      selectedPosition: null,
    }
  },
  computed: {
    ...mapGetters({
      postCheck: 'postCheck',
      testimonials: 'baseX/testimonials',
      positions: 'baseX/positions',
      loadingBtn: 'loadingBtn',
      imageUrl: 'imageUrl',
      thumbUrl: 'thumbUrl',
    }),
  },
  watch: {
    postCheck() {
      if (this.postCheck === true) {
        this.addModal = false;
        this.editModal = false;
        this.delModal = false;
        this.reloadContent();
        this.reloadFields();
      }
    },
    imageUrl() {
      if (this.imageUrl && this.imageUrl.length > 0) {
        this.refreshImage = false
        this.dropZoneAction = false
        this.form.imageName = this.imageUrl[0].fullPath
        this.form.imageAddress = this.imageUrl[0].fileAddress
        this.$nextTick(() => {
          this.refreshImage = true
        });
        setTimeout(() => {
          this.$store.commit("setLoadingBtn", false);
        }, 800);
      }
    },
    thumbUrl() {
      if (this.thumbUrl && this.thumbUrl.length > 0) {
        this.refreshImage2 = false
        this.dropZoneAction2 = false
        this.form.imageName2 = this.thumbUrl[0].fullPath
        this.form.imageAddress2 = this.thumbUrl[0].fileAddress
        this.$nextTick(() => {
          this.refreshImage2 = true
        });
        setTimeout(() => {
          this.$store.commit("setLoadingBtn", false);
        }, 800);
      }
    },
  },
  methods: {
    add() {
      this.reloadFields();
      this.dropZoneAction = true;
      this.dropZoneAction2 = true;
      this.$store.commit("setUrlsEmpty");
      this.addModal = true;
    },
    addTestimonials() {
      this.$store.commit("setLoadingBtn", true);
      if (this.form.customerName != null && this.form.customerName !== '' &&
          this.form.body && this.form.body != ''
          && this.form.imageName && this.form.imageName != '') {
        this.$store.dispatch('baseX/addTestimonials', this.form);
        this.dropZoneAction = true
      } else {
        this.$store.commit('setError', alert.error.empty)
      }
        this.$store.commit("setLoadingBtn", false);
    },
    edit(item) {
      this.form = {
        id: item.data.id,
        customerName: item.data.customerName,
        body: item.data.body,
        isConfirm: item.data.isConfirm,
        imageName: item.data.imageName,
        imageAddress: item.data.imageAddress,
        languageId: item.data.languageId,
      };
      this.editModal = true;
    },
    editTestimonials() {
      this.$store.commit("setLoadingBtn", true);
      if (this.form.customerName != null && this.form.customerName !== '' &&
          this.form.body != null && this.form.body !== '' &&
          this.form.imageName != null && this.form.imageName !== '') {
        this.$store.dispatch('baseX/editTestimonials', this.form);
      } else {
        this.$store.commit('setError', alert.error.empty)
      }
      this.$store.commit("setLoadingBtn", false);
    },
    setBody(item) {
      this.body = item.data.body;
      this.bodyModal = true;
    },
    del(item) {
      this.delId = item.data.id;
      this.delTitle = item.data.customerName;
      this.delModal = true;
    },
    deletePoster() {
      this.$store.commit("setLoadingBtn", true);
      this.$store.dispatch('baseX/deleteTestimonials', this.delId);
    },
    reloadFields() {
      this.form = {
        customerName: '',
        body: '',
        isConfirm: true,
        imageName: '',
        imageAddress: '',
        languageId: this.selectedLanguage,
      };
      this.selectedPosition = null;
      this.file = null;
      this.file2 = null;
      this.$store.commit("setLoadingBtn", false);
    },
    reloadContent() {
      this.$store.dispatch('baseX/getTestimonials', this.selectedLanguage);
    },
  },
  mounted() {
    this.reloadContent();
  },
}
</script>
